// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Paper,
//   CircularProgress,
//   Alert,
//   IconButton,
//   Tooltip,
//   TextField,
//   InputAdornment,
// } from '@mui/material';
// import {
//   Close as CloseIcon,
//   Search as SearchIcon,
//   Refresh as RefreshIcon,
//   Download as DownloadIcon,
//   FilterList as FilterIcon,
// } from '@mui/icons-material';

// import { DataGridPro } from '@mui/x-data-grid-pro';
// import { useToast } from '../../hooks/useToast';
// import { formatDateTime, initializeFormats, getFormatConfig } from '../../../utils/global';

// const GlobalOutputGrid = ({ open, onClose, data }) => {
//   const [outputData, setOutputData] = useState(data || []);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [dateTimeFormat, setDateTimeFormat] = useState('DD/MM/YYYY hh:mm:ss a');

//   const { showSuccess, showError } = useToast();

//   // Initialize formats when component mounts
//   useEffect(() => {
//     const tenantId = localStorage.getItem('tenant_id');
//     if (tenantId) {
//       initializeFormats(tenantId).then(() => {
//         const config = getFormatConfig();
//         if (config.DateTimeFormat) {
//           setDateTimeFormat(config.DateTimeFormat);
//         }
//       });
//     }
//   }, []);

//   // Load output data when dialog opens or when data prop changes
//   useEffect(() => {
//     if (open && data) {
//       setOutputData(Array.isArray(data) ? data : []);
//       showSuccess('Output data loaded successfully');
//     }
//   }, [open, data]);

//   const handleRefresh = () => {
//     if (data) {
//       setOutputData(Array.isArray(data) ? data : []);
//     }
//   };

//   const handleExport = () => {
//     try {
//       // Create headers for all columns
//       const headers = ['Process ID', 'Sort Order', ...Array.from({ length: 80 }, (_, i) => {
//         const colNumber = (i + 1).toString().padStart(2, '0');
//         return `Column ${colNumber}`;
//       })];

//       // Create data rows for all columns
//       const csvContent = [
//         headers.join(','),
//         ...filteredData.map(row => [
//           row.PROCESS_ID || '',
//           row.SORT_ORDER || '',
//           ...Array.from({ length: 80 }, (_, i) => {
//             const colNumber = (i + 1).toString().padStart(2, '0');
//             return row[`COL_${colNumber}`] || '';
//           })
//         ].join(','))
//       ].join('\n');

//       const blob = new Blob([csvContent], { type: 'text/csv' });
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `treasury_payment_output_${new Date().toISOString().split('T')[0]}.csv`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       window.URL.revokeObjectURL(url);

//       showSuccess('Data exported successfully');
//     } catch (error) {
//       console.error('Export error:', error);
//       showError('Failed to export data');
//     }
//   };

//   // Filter data based on search query
//   const filteredData = outputData.filter(row => {
//     if (!searchQuery) return true;

//     const query = searchQuery.toLowerCase();
//     return (
//       (row.PROCESS_ID && row.PROCESS_ID.toString().toLowerCase().includes(query)) ||
//       (row.SORT_ORDER && row.SORT_ORDER.toString().toLowerCase().includes(query)) ||
//       Array.from({ length: 80 }, (_, i) => {
//         const colNumber = (i + 1).toString().padStart(2, '0');
//         const colValue = row[`COL_${colNumber}`];
//         return colValue && colValue.toString().toLowerCase().includes(query);
//       }).some(Boolean)
//     );
//   });

//   const columns = [
//     {
//       field: 'PROCESS_ID',
//       headerName: 'Process ID',
//       flex: 1,
//       minWidth: 120,
//     },
//     {
//       field: 'SORT_ORDER',
//       headerName: 'Sort Order',
//       flex: 0.8,
//       minWidth: 100,
//     },
//     ...Array.from({ length: 80 }, (_, i) => {
//       const colNumber = (i + 1).toString().padStart(2, '0');
//       return {
//         field: `COL_${colNumber}`,
//         headerName: `Column ${colNumber}`,
//         flex: 1,
//         minWidth: 120,
//       };
//     }),
//   ];

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="xl"
//       fullWidth
//       PaperProps={{
//         sx: {
//           height: '90vh',
//           maxHeight: '90vh',
//         },
//       }}
//     >
//       <DialogTitle sx={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'center',
//         pb: 2,
//       }}>
//         <Typography variant="h6" sx={{ fontWeight: 600 }}>
//           Treasury Payment Output Grid
//         </Typography>
//         <Box sx={{ display: 'flex', gap: 1 }}>
//           <Tooltip title="Export to CSV">
//             <IconButton onClick={handleExport} disabled={loading || filteredData.length === 0}>
//               <DownloadIcon />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Refresh">
//             <IconButton onClick={handleRefresh} disabled={loading}>
//               <RefreshIcon />
//             </IconButton>
//           </Tooltip>
//           <IconButton onClick={onClose}>
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ pb: 2 }}>
//         {/* Search Bar */}
//         <Box sx={{ mb: 2 }}>
//           <TextField
//             fullWidth
//             placeholder="Search by Process ID, Sort Order, or any column value..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon />
//                 </InputAdornment>
//               ),
//             }}
//             size="small"
//           />
//         </Box>

//         {/* Error Display */}
//         {error && (
//           <Alert severity="error" sx={{ mb: 2 }}>
//             {error}
//           </Alert>
//         )}

//         {/* Data Grid */}
//         <Paper sx={{ 
//           height: 'calc(90vh - 200px)', 
//           display: 'flex', 
//           flexDirection: 'column',
//           overflow: 'hidden'
//         }}>
//           {loading ? (
//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'center', 
//               alignItems: 'center', 
//               height: '100%' 
//             }}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             <DataGridPro
//               rows={filteredData.map((row, index) => ({ ...row, _id: `${row.PROCESS_ID}-${row.SORT_ORDER}-${index}` }))}
//               columns={columns}
//               getRowId={(row) => row._id}
//               columnResizeMode="onEnd"
//               resizable
//               pagination
//               rowsPerPageOptions={[10, 25, 50, 100]}
//               pageSize={25}
//               sx={{
//                 '& .MuiDataGrid-root': {
//                   border: 'none',
//                 },
//                 '& .MuiDataGrid-columnHeaders': {
//                   backgroundColor: 'background.paper',
//                   fontWeight: 600,
//                   fontSize: '0.875rem',
//                 },
//                 '& .MuiDataGrid-cell': {
//                   fontSize: '0.875rem',
//                 },
//                 '& .MuiDataGrid-virtualScroller': {
//                   overflowX: 'auto',
//                 },
//               }}
//               initialState={{
//                 pagination: {
//                   paginationModel: { page: 0, pageSize: 25 },
//                 },
//               }}
//               disableRowSelectionOnClick
//             />
//           )}
//         </Paper>
//       </DialogContent>

//       <DialogActions sx={{ px: 3, pb: 3 }}>
//         <Typography variant="body2" color="textSecondary" sx={{ mr: 'auto' }}>
//           {filteredData.length} records found
//         </Typography>
//         {/* <Button onClick={onClose} variant="outlined">
//           Close
//         </Button> */}
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default GlobalOutputGrid;

import React, { useState, useEffect } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Paper,
  CircularProgress,
  Alert,
  IconButton,
  Tooltip,
  TextField,
  InputAdornment,
} from '@mui/material';
import {
  Close as CloseIcon,
  Search as SearchIcon,
  Refresh as RefreshIcon,
  Download as DownloadIcon,
  FilterList as FilterIcon,
  Settings as ConfigIcon,
} from '@mui/icons-material';

import { DataGridPro } from '@mui/x-data-grid-pro';
import { useToast } from '../../hooks/useToast';
import { useFunctionPermissions } from '../../../hooks/useFunctionPermissions';
import { FC } from '../../../constants/functionCodes';
import { formatDateTime, initializeFormats, getFormatConfig } from '../../../utils/global';

const GlobalOutputGrid = ({ open, onClose, data }) => {
  const { canExport } = useFunctionPermissions(FC.PAYMENT_INTELLIGENCE);
  const [outputData, setOutputData] = useState(data || []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateTimeFormat, setDateTimeFormat] = useState('DD/MM/YYYY hh:mm:ss a');
  const [isConfigView, setIsConfigView] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [formattedData, setFormattedData] = useState([]);

  const { showSuccess, showError } = useToast();

  // Initialize formats when component mounts
  useEffect(() => {
    const tenantId = localStorage.getItem('tenant_id');
    if (tenantId) {
      initializeFormats(tenantId).then(() => {
        const config = getFormatConfig();
        if (config.DateTimeFormat) {
          setDateTimeFormat(config.DateTimeFormat);
        }
      });
    }
  }, []);

  // Load output data when dialog opens or when data prop changes
  useEffect(() => {
    if (open && data) {
      setOutputData(Array.isArray(data) ? data : []);
      showSuccess('Output data loaded successfully');
    }
  }, [open, data]);

  const handleRefresh = () => {
    if (data) {
      setOutputData(Array.isArray(data) ? data : []);
    }
  };

  // Fetch configuration for config view
  const fetchConfig = async () => {
    try {
      const token = localStorage.getItem('token');
      const tenantId = localStorage.getItem('tenant_integration');

      if (!tenantId) {
        throw new Error('Tenant information not found');
      }

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}conductor/config/default?category=PAYMENTS_WIRE_JPMC_FREEFORM_VIEW`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch config: ${response.status}`);
      }

      const config = await response.json();
      setConfigData(config);
      return config;
    } catch (err) {
      console.error('Error fetching config:', err);
      showError('Failed to load configuration');
      throw err;
    }
  };

  // Format data based on configuration
  const formatDataWithConfig = (data, config) => {
    if (!config || !config.grid || !config.grid.columns) {
      return data;
    }

    return data.map(item => {
      const newItem = { ...item };
      config.grid.columns.forEach(col => {
        if (newItem[col.name] === undefined) {
          newItem[col.name] = null;
        }
      });
      return newItem;
    });
  };

  // Handle config view toggle
  const handleConfigView = async () => {
    if (!isConfigView) {
      setLoading(true);
      try {
        const config = await fetchConfig();
        const formatted = formatDataWithConfig(outputData, config);
        setFormattedData(formatted);
        setIsConfigView(true);
        showSuccess('Config view loaded successfully');
      } catch (err) {
        console.error('Error loading config view:', err);
      } finally {
        setLoading(false);
      }
    } else {
      setIsConfigView(false);
    }
  };

  // Generate columns from configuration
  const generateColumnsFromConfig = (config) => {
    if (!config || !config.grid || !config.grid.columns) return [];

    return config.grid.columns.map(column => {
      const dataType = column.DataType?.toLowerCase() || 'string';
      const isDate = dataType === 'date' || dataType === 'datetime';
      const isNumber = dataType === 'number' || dataType === 'integer' || dataType === 'float';

      return {
        field: column.name,
        headerName: column.title || column.name,
        type: isNumber ? 'number' : 'string',
        width: column.width || 150,
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => {
          const value = params.value;
          if (value === null || value === undefined) return '';
          if (typeof value === 'object') return JSON.stringify(value);
          return value;
        },
        valueFormatter: (params) => {
          const value = params.value;
          if (value === null || value === undefined) return '';

          try {
            if (isDate) {
              return formatDateTime(value, dateTimeFormat);
            } else if (isNumber) {
              const numValue = parseFloat(value);
              if (isNaN(numValue)) return value;
              return numValue.toLocaleString();
            }
          } catch (e) {
            console.error(`Error formatting value for ${column.name}:`, e);
            return value;
          }

          return String(value);
        },
        sortable: true,
        filterable: true,
      };
    });
  };

  const columns = [
    ...Array.from({ length: 80 }, (_, i) => {
      const colNumber = (i + 1).toString().padStart(2, '0');
      return {
        field: `COL_${colNumber}`,
        headerName: `Column ${colNumber}`,
        flex: 1,
        minWidth: 120,
      };
    }),
  ];

  // Get current data and columns based on view mode
  const currentData = isConfigView ? formattedData : outputData;
  const currentColumns = isConfigView ? generateColumnsFromConfig(configData) : columns;

  // Filter data based on search query
  const filteredData = currentData.filter(row => {
    if (!searchQuery) return true;

    const query = searchQuery.toLowerCase();
    if (isConfigView) {
      return Object.values(row).some(value =>
        value && value.toString().toLowerCase().includes(query)
      );
    } else {
      return (
        (row.PROCESS_ID && row.PROCESS_ID.toString().toLowerCase().includes(query)) ||
        (row.SORT_ORDER && row.SORT_ORDER.toString().toLowerCase().includes(query)) ||
        Array.from({ length: 80 }, (_, i) => {
          const colNumber = (i + 1).toString().padStart(2, '0');
          const colValue = row[`COL_${colNumber}`];
          return colValue && colValue.toString().toLowerCase().includes(query);
        }).some(Boolean)
      );
    }
  });

  // const handleExport = () => {
  //   try {
  //     const headers = ['Process ID', 'Sort Order', ...Array.from({ length: 80 }, (_, i) => {
  //       const colNumber = (i + 1).toString().padStart(2, '0');
  //       return `Column ${colNumber}`;
  //     })];

  //     const csvContent = [
  //       headers.join(','),
  //       ...filteredData.map(row => [
  //         row.PROCESS_ID || '',
  //         row.SORT_ORDER || '',
  //         ...Array.from({ length: 80 }, (_, i) => {
  //           const colNumber = (i + 1).toString().padStart(2, '0');
  //           return row[`COL_${colNumber}`] || '';
  //         })
  //       ].join(','))
  //     ].join('\n');

  //     const blob = new Blob([csvContent], { type: 'text/csv' });
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = `treasury_payment_output_${new Date().toISOString().split('T')[0]}.csv`;
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     window.URL.revokeObjectURL(url);

  //     showSuccess('Data exported successfully');
  //   } catch (error) {
  //     console.error('Export error:', error);
  //     showError('Failed to export data');
  //   }
  // };

  const handleExport = () => {
    if (!canExport) return;
    try {
      let headers, csvContent;

      if (isConfigView && configData?.grid?.columns) {
        // Config view: use config column names and titles
        const configColumns = configData.grid.columns;

        headers = configColumns.map(col => col.title || col.name);

        csvContent = [
          headers.join(','),
          ...filteredData.map(row =>
            configColumns.map(col => {
              const value = row[col.name];
              return value !== null && value !== undefined ? `"${String(value).replace(/"/g, '""')}"` : '';
            }).join(',')
          )
        ].join('\n');
      } else {
        // Normal view: use original COL_01, COL_02... logic
        headers = ['Process ID', 'Sort Order', ...Array.from({ length: 80 }, (_, i) => {
          const colNumber = (i + 1).toString().padStart(2, '0');
          return `Column ${colNumber}`;
        })];

        csvContent = [
          headers.join(','),
          ...filteredData.map(row => [
            row.PROCESS_ID || '',
            row.SORT_ORDER || '',
            ...Array.from({ length: 80 }, (_, i) => {
              const colNumber = (i + 1).toString().padStart(2, '0');
              return row[`COL_${colNumber}`] || '';
            })
          ].join(','))
        ].join('\n');
      }

      const blob = new Blob([csvContent], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `treasury_payment_output_${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      showSuccess('Data exported successfully');
    } catch (error) {
      console.error('Export error:', error);
      showError('Failed to export data');
    }
  };
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          height: '90vh',
          maxHeight: '90vh',
        },
      }}
    >
      <DialogTitle sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pb: 2,
      }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Treasury Payment Output Grid {isConfigView && '(Config View)'}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Tooltip title="Config View">
            <IconButton onClick={handleConfigView} disabled={loading}>
              <ConfigIcon />
            </IconButton>
          </Tooltip>
          {canExport && (
          <Tooltip title="Export to CSV">
            <IconButton onClick={handleExport} disabled={loading || filteredData.length === 0}>
              <DownloadIcon />
            </IconButton>
          </Tooltip>
          )}
          {/* <Tooltip title="Refresh">
            <IconButton onClick={handleRefresh} disabled={loading}>
              <RefreshIcon />
            </IconButton>
          </Tooltip> */}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pb: 2 }}>
        {/* Search Bar */}
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            placeholder="Search by Process ID, Sort Order, or any column value..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            size="small"
          />
        </Box>

        {/* Error Display */}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {/* Data Grid */}
        <Paper sx={{
          height: 'calc(90vh - 200px)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
          {loading ? (
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
            }}>
              <CircularProgress />
            </Box>
          ) : (
            <DataGridPro
              rows={filteredData.map((row, index) => ({ ...row, _id: `${row.PROCESS_ID}-${row.SORT_ORDER}-${index}` }))}
              columns={currentColumns}
              getRowId={(row) => row._id}
              columnResizeMode="onEnd"
              resizable
              pagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              pageSize={25}
              sx={{
                '& .MuiDataGrid-root': {
                  border: 'none',
                },
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: 'background.paper',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                },
                '& .MuiDataGrid-cell': {
                  fontSize: '0.875rem',
                },
                '& .MuiDataGrid-virtualScroller': {
                  overflowX: 'auto',
                },
              }}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 25 },
                },
              }}
              disableRowSelectionOnClick
            />
          )}
        </Paper>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Typography variant="body2" color="textSecondary" sx={{ mr: 'auto' }}>
          {filteredData.length} records found
        </Typography>
      </DialogActions>
    </Dialog>
  );
};

export default GlobalOutputGrid;